import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { deactivateModal } from '../../store/actions';

import './Modal.css';

export default function withModal(WrappedComponent, name) {
  class ModalWrapper extends Component {
    render() {
      const { onModalClick, modal, id, modalName } = this.props;
      const nameToUse = modalName || name;
      const activeName = id ? `${nameToUse}-${id}` : nameToUse;
      if (modal !== activeName) {
        return null;
      }
      return (
        <div className="modal">
          <WrappedComponent onModalClick={onModalClick} {...this.props} />
          <a
            tabIndex="0"
            onClick={() => { onModalClick(); }}
          >
            <div className="modal-closer" />
          </a>
        </div>
      );
    }
  }

  ModalWrapper.propTypes = {
    onModalClick: PropTypes.func,
    modal: PropTypes.string,
    id: PropTypes.string,
    modalName: PropTypes.string,
  };

  function mapStateToProps(state) {
    return {
      modal: state.modal,
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      onModalClick: () => { dispatch(deactivateModal()); },
    };
  }
  return connect(mapStateToProps, mapDispatchToProps)(ModalWrapper);
}



// WEBPACK FOOTER //
// ./src/components/Modal/WithModal.js